import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCircleCheck,
    faDoorClosed,
    faDoorOpen,
    faLock,
    faLockOpen,
    faRotate,
    faSortDown,
    faSortUp,
    faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";

export const API_V1 = "api/v1";
export const API_AUTH_V1 = "api/auth/v1";
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GMAP_API_KEY || "AIzaSyCgHzdgtGnfzIRCo_fhuoUrcAudNJVAiFg";
// Google *vector* Map ID (created in Google Cloud Console → Map Management). Heading/rotation
// (the live-map "heading-up" navigation view, where the vehicle always travels toward the top of
// the screen) ONLY works on a vector map, which requires a Map ID. Leave empty to keep the classic
// north-up raster map (default, zero change). Set REACT_APP_GMAP_VECTOR_MAP_ID to enable heading-up.
export const GOOGLE_MAPS_VECTOR_MAP_ID = process.env.REACT_APP_GMAP_VECTOR_MAP_ID || "";
export const BASE_URL = process.env.REACT_APP_BASE_URL || "https://www.yekkada.com/";
export const GMAP_LOCATION_API_URL =
  "https://maps.googleapis.com/maps/api/geocode/json?";
export const LOGGED_IN_USER = "loggedInUser";
export const IS_AUTHENTICATED = "isAuthenticated";
export const EP_ASSETS_GET_ALL = "assets/getAllAssets";
export const LOGIN = "login";
export const NO_INFO = "NA";
export const OFFLINE_TIMEOUT = 90000;
export const COMP_DASHBOARD = "Dashboard";
export const BEARER = "Bearer ";
export const LOCK_CLOSE = (
  <span className="status-icon-group">
    <FontAwesomeIcon className="icon-primary" size="xl" icon={faLock} fade />
    Inserted
  </span>
);
export const LOCK_OPEN = (
  <span className="status-icon-group">
    <FontAwesomeIcon className="icon-accent" size="xl" icon={faLockOpen} shake />
    Unplugged
  </span>
);
export const BACK_COVER_CLOSE = (
  <span className="status-icon-group">
    <FontAwesomeIcon className="icon-primary" size="xl" icon={faDoorClosed} fade />
    Closed
  </span>
);
export const BACK_COVER_OPEN = (
  <span className="status-icon-group">
    <FontAwesomeIcon className="icon-accent" size="xl" icon={faDoorOpen} shake />
    Open
  </span>
);
export const NORMAL = (
  <span className="status-icon-group">
    <FontAwesomeIcon icon={faCircleCheck} size="xl" className="icon-primary" />
    No
  </span>
);
export const ALERT_WARNING = (
  <span className="status-icon-group">
    <FontAwesomeIcon icon={faTriangleExclamation} size="xl" fade className="icon-accent" />
    Yes
  </span>
);
export const LOADING_ARROW = (
  <FontAwesomeIcon icon={faRotate} spin size="lg" className="icon-muted" />
);
export const DEVICE_OFFLINE = (
  <span className="device-status-offline">Offline</span>
);
export const DEVICE_ONLINE = (
  <span className="device-status-online">Online</span>
);
export const GPS_WEBSOCKET = "gps-websocket";
export const TOPIC_DEVICE_STATUS = "/topic/deviceStatus";
export const TOPIC_SCHEDULED_UNLOCKS = "/topic/scheduled-unlocks";
export const EP_ASSETS_ONLINE_STATUS = "assets/online-status";
export const FAIL = "Fail";
export const SUCCESS = "Success";
export const LOCKED = "Locked";
export const OPEN = "Open";
export const CLIENT_ADMIN = "CLIENT_ADMIN";
export const SELECTED = "selected";
export const USERS = "Users";
export const ASSETS = "Assets";
export const TRACKING = "Tracking";
export const TASK = "Task";
export const SETTINGS = "Settings";
export const PROFILE = "Profile";
export const REPORTS = "Reports";
export const ANALYTICS = "Analytics";
export const SORT_UP = (
  <FontAwesomeIcon className="icon-primary" size="xs" icon={faSortUp} fade />
);
export const SORT_DOWN = (
  <FontAwesomeIcon className="icon-primary" size="xs" icon={faSortDown} fade />
);
export const TOAST_TIMEOUT = 2500;
export const FETCH_REPORTS="Fetch Reports";
export const CLEAR_FILTERS="Clear Filters";
export const AUDIT_LOG = "Audit Trail";
export const COMMAND_CENTER = "Command Center";
export const TRIPS = "Fleet Trips";
